
// const Home = r => require.ensure([], () => r(require('views/Home')));
import Vue from "vue";
import error from '@/components/error';
import errorlog_platformSDBao from '@/components/errorlog_platformSDBao';
import errorlog from '@/components/errorlog';
import print from '@/components/print';
import VueRouter from "vue-router";
Vue.use(VueRouter);
let routes = [
    {
        path: '/errorlog_platformSDBao',
        component: errorlog_platformSDBao,
        meta:{
            title:'错误日志'
        }
    },
    {
        path: '/errorlog',
        component: errorlog,
        meta:{
            title:'错误日志'
        }
    },
    {
        path:'/print',
        component: print,
        meta:{
            title:'打印'
        }
    },
    {
        path:'*',
        component: error,
    }
];


const router = new VueRouter({
     mode: 'history',
    routes,
});
export default router;
